export default __webpack_public_path__ + "static/media/loha_fms1.89559661.jpg";